import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchAccionesLiquidaciones } from '../../../../actions/LiquidacionesActions';
import { postNuevaNovedadConcepto } from '../../../../api/axios';
import { DropDownArrow } from "../../../../template/CustomStyle";
import { EstiloCombos } from '../../../../template/CustomStyle';
import { toast } from 'react-toastify';
import Select from 'react-select';
import GoBackArrow from '../../../General/GoBackArrow';

// Wrapper para usar hooks en class component
function ConceptoNewWrapper(props) {
  const navigate = useNavigate();
  return <ConceptoNew {...props} navigate={navigate} />;
}

class ConceptoNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comboLiquidacionAcciones: { label: "", value: "" },
            request: null
        };
        this.nombreInputRef = React.createRef();
    };

    componentDidMount() {
        this.props.fetchAccionesLiquidaciones();
        localStorage.setItem('NuevaNovedadAcciones', "");

        if (this.nombreInputRef.current) {
            this.nombreInputRef.current.focus();
        }
    }

    regresar = () => {
        this.props.navigate("/Conceptos");
    }

    selectSearchHandlerLiquidacionesAcciones = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({
            comboLiquidacionAcciones: valor
        })
        localStorage.setItem('NuevaNovedadAcciones', options.value);
    }

    onSubmit = async (event) => {
        event.preventDefault();

        if (document.getElementById("NuevaNovedadNombre").value == "") {
            toast.warn("Debe agregar un nombre ");
            return;
        }

        if (localStorage.getItem('NuevaNovedadAcciones') == "" || localStorage.getItem('NuevaNovedadAcciones') == undefined) {
            toast.warn("Debe seleccionar una acción");
            return;
        }

        //me traigo el valor idSubTipo
        let idSubTipo = parseInt(localStorage.getItem('NuevaNovedadAcciones'));

        //busco dentro del array si coincide id=idSubTipo
        let accionSeleccionada = this.props.lista_acciones_liquidaciones.find(accion => accion.idEstado === idSubTipo);

        //busco la descripción 
        let descripcionAccion = accionSeleccionada ? accionSeleccionada.descripcion : "";

        let data = {
            concepto: document.getElementById("NuevaNovedadNombre").value,
            idSubTipo: idSubTipo,
            descripcionSubTipo: descripcionAccion,
            //idTipoNovedad:
            mostrarBotonEliminar: true
        };

        let post = postNuevaNovedadConcepto(data);

        post.then(res => {
            toast.success("El concepto de la novedad fue creada con éxito");
            document.getElementById("NuevaNovedadNombre").value = "";
            document.getElementById("NuevaNovedadNombre").focus();
            return;
        }).catch(err => {
            toast.error("No pudimos crear el concepto de novedad");
        });
    }


    render() {

        let listaAccionesLiquidacion = [];
        if (this.props.lista_acciones_liquidaciones != undefined) {
            this.props.lista_acciones_liquidaciones.map((tipo) => {
                listaAccionesLiquidacion.push({ label: tipo.descripcion, value: tipo.idEstado })
            })
        };

        let selectListaAcciones = 
        <div>
            <p className="font-bold">Acción</p>
            <Select
                name="NuevaLiquidacionAcciones"
                id="NuevaLiquidacionAcciones"
                value={this.state.comboLiquidacionAcciones}
                options={listaAccionesLiquidacion}
                onChange={this.selectSearchHandlerLiquidacionesAcciones}
                styles={EstiloCombos}
                components={{ DropdownIndicator: () => DropDownArrow }}
            />
        </div>


        return (
            <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                <div className="ibox-content">
                    <div className="card">
                        <div className="card-body row justify-content-evenly">

                            <div className="card-title mb-3 col-12">
                                <div className="row">
                                    <div className="col-12 col-sm-auto">
                                        <GoBackArrow/>
                                    </div>
                                    <div className="col-12 col-sm-auto">
                                        <h4>Crear Concepto</h4>
                                    </div>
                                </div>
                            </div>


                            <div className="col-12 col-md-4">
                                <p className="font-bold">Nombre</p>
                                <input 
                                    type="text" 
                                    name="NuevaNovedadNombre" 
                                    id="NuevaNovedadNombre" 
                                    className="form-control"
                                    ref={this.nombreInputRef}
                                />
                            </div>

                            <div className="col-12 col-md-3">
                            {
                                this.props.tipoUsuario !== 2 ? 
                                selectListaAcciones : selectListaAcciones
                            }
                            </div>

                            <div className="col-12 ibox-content float-e-margins mt-3">
                                <div className="row justify-content-center align-items-center">
                                    <button 
                                        type="submit" 
                                        className="btn btn-sm background-rojo-megatone col-auto mx-2"
                                    >
                                        Confirmar
                                    </button>

                                    <button 
                                        onClick={this.regresar} 
                                        type="button" 
                                        className="btn btn-sm btn-light col-auto mx-2"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => ({
    lista_acciones_liquidaciones: state.liquidaciones.lista_acciones_liquidaciones,
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    tiposConceptos: state.tipos.tipoLiquidacionConcepto,
    tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps, { fetchAccionesLiquidaciones }) (ConceptoNewWrapper);